<template>
  <v-container>
    <v-row
      class="white"
      dense
    >
      <v-col
        class="py-0"
      >
        <h3 class="ml-3">{{ $t('conflict.inThisScenario') }}</h3>
        <conflict
          :conflict="conflict"
          :show-details="debugMode"
        />
      </v-col>
    </v-row>
    <v-row
      class="my-3 raison-highlight"
      dense
    >
      <v-col>
        <h3 class="pa-3">{{ hasGroups ? $t('conflict.chooseYourFavoriteGroup') : $t('conflict.chooseYourFavoriteOption') }}:</h3>
        <wigo-chooser
          :wigos="conflict.wigos"
          @wigoSelected="$emit('wigoSelected', $event)"
          :show-details="debugMode"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Conflict from '@/components/conflictResolution/Conflict'
import WigoChooser from '@/components/conflictResolution/WigoChooser'

import debugModeMixin from '@/mixins/debug-mode-mixin.js'

export default ({
  name: 'ChooseExclusiveAndUniqueWigo',

  components: {
    Conflict,
    WigoChooser
  },

  mixins: [ debugModeMixin ],

  data () {
    return {
      loading: false
    }
  },

  props: {
    conflict: {
      type: Object,
      required: true
    }
  },

  computed: {
    hasGroups() {
      return this.conflict.wigos?.some(wigo => wigo.length > 1)
    },
  },

  methods: {

  },

})
</script>
<style>
</style>